import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Slider from "@mui/material/Slider";
import { ReactComponent as Sign } from "../../../assets/images/sign.svg";
import { ReactComponent as Upload } from "../../../assets/images/Upload-Red.svg";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import "./CustomerDocs.scss";
import { Title } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, SvgIcon } from "@mui/material";
import { open } from "../../../redux/actions/modalActions";
import { currentDoc } from "../../../redux/actions/dataActions";

function CustomerDocs(props) {
  const { data, signature_sent } = useSelector((state) => state.data);
  const dispatch = useDispatch();

  const openDialog = (doc) => {
    dispatch(currentDoc(doc))
    dispatch(open(doc.popup));
  };

  return (
    <Card className="uti-docs-box">
      <CardHeader title={"מסמכי משאית צד לקוח"}></CardHeader>
      <CardContent>
        <div className="scroll_cont">
          <div className="docs-card">
            {data?.customerDocuments &&
              data?.customerDocuments.filter(cd => !signature_sent.some(item => item.type === cd.documentType)).map((doc) => (
                <Button
                  onClick={() => openDialog(doc)}
                  className="req_button"
                  disabled={!doc.active}
                >
                  <SvgIcon
                    component={doc.sign ? Sign : Upload}
                    className="doc_icon"
                    inheritViewBox
                  />
                  <div className ={doc.sublabel ? "label_with_subtitle" : "label_without_subtitle"}>{doc.label}</div>
                  <div className="Sub_title">{doc.sublabel}</div>
                  <div
                    className={`btn_footer ${
                      doc.sign ? "footer_light" : "footer_link"
                    }`}
                  >
                    {doc.fill
                      ? "למילוי וחתימה"
                      : doc.sign
                      ? "לחתימה דיגיטלית"
                      : "העלאת קובץ"}
                  </div>
                </Button>
              ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default CustomerDocs;
